export const TAGLINE = "Your AI Manager Assistant";

export const TAGLINE_SUBTITLE =
  "Management hasn't changed in decades. It's time for a new approach.";
